import { render, staticRenderFns } from "./SelectInhaler.vue?vue&type=template&id=61e61c25&"
import script from "./SelectInhaler.vue?vue&type=script&lang=js&"
export * from "./SelectInhaler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports